import { createSlice } from '@reduxjs/toolkit';
const INITIAL_STATE = {
    blacklist: []
};
const settingsSlice = createSlice({
    name: 'validation',
    initialState: INITIAL_STATE,
    reducers: {
        setWhitelist (_, action) {
            return {
                whitelist: action.payload
            };
        },
        setBlacklist (_, action) {
            return {
                blacklist: action.payload
            };
        }
    }
});
const { actions, reducer } = settingsSlice;
export const validationReducer = reducer;
export const { setWhitelist, setBlacklist } = actions;
export const ValidationActions = {
    setWhitelist,
    setBlacklist
};
